import fetchServer from "../../fetchServer";

export default async function getAPIKeys({ limit = 10, offset = 0 } = {}) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching API keys!",
    data: [],
    meta: { limit, offset, total: 0 },
  };

  const params = new URLSearchParams();
  params.set("limit", String(limit));
  params.set("offset", String(offset));

  await fetchServer({
    method: "GET",
    url: `/main/v1/apikey?${params.toString()}`,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        const payload = res?.data?.data;
        const items = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : [];
        const meta = payload?.meta || {
          limit,
          offset,
          total: items.length,
        };

        result = {
          return: 1,
          msg: res?.data?.message || "Successful",
          data: items,
          meta,
        };
      } else if (res?.data?.error) result["msg"] = res.data.error;
      else if (res?.error) result["msg"] = res.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
